import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { SubscriberReset } from '@x/ecommerce-shop/app/subscriber-checkout/state/subscriber.actions';
import { SubscriberState } from '@x/ecommerce-shop/app/subscriber-checkout/state/subscriber.state';
import { IShopSubscriber } from '@x/ecommerce/shop-client';
import { Observable } from 'rxjs';

@Component({
  selector: 'x-subscriber-success-page',
  templateUrl: './subscriber-success-page.component.html',
  styleUrls: ['./subscriber-success-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'x-subscriber-success-page',
  },
})
export class SubscriberSuccessPageComponent implements OnDestroy {
  @Select(SubscriberState.subscriber)
  subscriber$: Observable<IShopSubscriber>;

  constructor(private store: Store) {}

  backToShopping() {
    this.store.dispatch(new SubscriberReset());
  }

  ngOnDestroy(): void {
    this.store.dispatch(new SubscriberReset());
  }
}
